import React, { useState, useEffect } from "react";
import "./SimulatorDashboard.scss";
import Popup1 from "../../Crew/popup1";
import apollo_client from "../../../../apollo_client";
import moment from "moment";
import firebase from "../../../../Firebase/firebase";
import {
  simrecordsQuery,
  simDashboardMessage,
  simDashboardApprovalstatus,
} from "./Queries/SimulatorDashboardQuery";
import "../../../../assets/styles/custom/components/dashboard/Crew.scss";

const SimulatorDashboard = () => {
  const [search, setsearch] = useState("");
  const [instVal, setinstVal] = useState(0)
  const [examVal, setexamVal] = useState(0)
  const [dashboardDetails, setdashboardDetails] = useState([]);
  const [dashboardStatus, setdashboardStatus] = useState([]);
  const [dashboardMessage, setdashboardMessage] = useState(null);
  const [popupToggle1, setpopupToggle1] = useState(false);
  const [Blankform, setBlankform] = useState("");
  const popup1 = (data) => {
    setpopupToggle1(!popupToggle1);
    setBlankform(data);
  };
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      // console.log("USERnaME" + JSON.stringify(user));
      if (user) {
        let dashboardDet = await apollo_client.query({
          query: simrecordsQuery,
          variables: {
            id: user.uid,
          },
        });
        let dashboardMes = await apollo_client.query({
          query: simDashboardMessage,
          variables: {
            id: user.displayName,
          },
        });
        let dashboardStatus = await apollo_client.query({
          query: simDashboardApprovalstatus,
          variables: {
            id: user.uid,
          }
        });

        console.log(JSON.stringify(dashboardStatus))
        console.log("Data1" + JSON.stringify(dashboardStatus.data?.aatmsv4_simulatorinst))
        console.log("Data2" + JSON.stringify(dashboardDet.data?.aatmsv4_simformrecords))


        setdashboardMessage(dashboardMes.data);
        setdashboardStatus(dashboardStatus.data?.aatmsv4_simulatorinst);
        setdashboardDetails(dashboardDet.data?.aatmsv4_simformrecords);
        setinstVal(moment(new Date(dashboardStatus.data?.aatmsv4_simulatorinst[0]?.instvalidity)).diff(moment(), "days") + 1);
        setexamVal(moment(new Date(dashboardStatus.data?.aatmsv4_simulatorinst[0]?.instvalidity)).diff(moment(), "days") + 1);
      }
    });
  }, []);

  return (
    <div className="simulator-dashboard">
      <div className="animate__animated animate__fadeIn">
        <div className="message-from-chief medium-margin-top">
          <div className="category-title">Message from chief of training</div>
          <div className="message-container">
            {dashboardMessage?.aatmsv4_clients[0]?.simulatormessage}
          </div>
        </div>

        {
          dashboardStatus && dashboardStatus.length > 0 && (
            <div className="message-from-chief medium-margin-top">
              
              {dashboardStatus[0].instvalidity !==null?(
              <div>
                <div className="category-title">Instructor approval status</div>
                <div className={instVal > 45 ? "message-container-green" : instVal >= 0 && instVal <= 45 ? "message-container-yellow" : "message-container"}>
                  <a className={
                  new Date( dashboardStatus[0].instvalidity).getTime()<new Date().getTime()
                    ?"textred tile blinking":"black"}
                    onClick={() => {
                      popup1(dashboardStatus[0]?.instructorapproval);
                    }}
                  > {new Date(
                    dashboardStatus[0]?.instvalidity
                  ).toLocaleDateString("hi-IN")}</a>
                </div>
              </div>):null}
              
              {dashboardStatus[0].examvalidity !==null?(
              <div className="message-from-chief medium-margin-top">
                <div className="category-title">Examiner approval status</div>
                <div className={examVal > 45 ? "message-container-green" : examVal >= 0 && examVal <= 45 ? "message-container-yellow" : "message-container"}>
                  <a className={ new Date( dashboardStatus[0].examvalidity).getTime()<new Date().getTime() ?"textred tile blinking":"black"}
                    onClick={() => {
                      popup1(dashboardStatus[0]?.examinerapproval);
                    }}
                  >{new Date(
                    dashboardStatus[0]?.examvalidity
                  ).toLocaleDateString("hi-IN")}</a>
                </div>
              </div>
              ):null} 
            </div>
          )
        }
        <div className="category-title medium-margin-top">
          List of simulator training completed by you
        </div>
      </div>
      {
        popupToggle1 === true ? (
          <Popup1 setpopupToggle1={setpopupToggle1} simulatorData={Blankform} />
        ) : null
      }
      <div className="table-body-container">
        <div className="search-bar">
          <label className="pdr10">Search</label>
          <input
            type="text"
            value={search}
            className="simulator-search"
            onChange={(e) => setsearch(e.target.value)}
          />
        </div>

        {dashboardDetails && dashboardDetails.length > 0 ? (
          <div>
            {dashboardDetails.map((data, index) => {
              if (data.simformname.includes(search)) {
                return (
                  <div className="row-top " key={index}>
                    <div className="items">
                      <div className="title">Date</div>
                      <div className="">{data.date}</div>
                    </div>
                    <div className="items">
                      <div className="title">Training / Check</div>
                      <div className="">
                        <a
                          onClick={() => {
                            popup1(data.simrecord);
                          }}
                        >
                          {data.simformname}
                        </a>
                      </div>
                    </div>
                    <div className="items">
                      <div className="title">Trainee Name</div>
                      <div className="">{data.traineename}</div>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        ) : (
            <div className="row">
              <div className="col-lg-12 title">No Forms Available</div>
            </div>
          )}
      </div>
    </div >
  );
};

export default SimulatorDashboard;
